import { convertTimeAllNumbers, getDayOfWeek } from '../dateTimeUtils'
import CourierMessaging from './CourierMessaging'

export interface IplannedPickupDateAndTimeUPS {
    CloseTime: string
    ReadyTime: string
    PickupDate: string
}

export default class UPSPickupMessaging implements CourierMessaging {
    constructor(
        private messages: any,
        private isPickupEarliestNow: boolean,
        private currentDate: string,
        private plannedPickupDateAndTime: IplannedPickupDateAndTimeUPS
    ) {}

    private formatPickupTime(): string {
        return this.isPickupEarliestNow
            ? this.messages.createCollection.timeSlot.now()
            : `${convertTimeAllNumbers(this.plannedPickupDateAndTime.ReadyTime)}`
    }

    formatTimePeriod(): string {
        const pickupTime = this.formatPickupTime()
        const pickupLatest = convertTimeAllNumbers(this.plannedPickupDateAndTime.CloseTime);
        return this.messages.createCollection.timeSlot.betweenTimeSlot({
            pickupTime, pickupLatest
        })
    }

    formatDatePeriod(): string {
        const currentDate = this.currentDate
        const plannedDate = this.plannedPickupDateAndTime.PickupDate

        const ppdYear = Number(this.plannedPickupDateAndTime.PickupDate.slice(0,4))
        const ppdMonth = Number(this.plannedPickupDateAndTime.PickupDate.slice(4, 6)) - 1
        const ppdDay = Number(this.plannedPickupDateAndTime.PickupDate.slice(6, 8))
        const formatPPD = new Date(ppdYear, ppdMonth, ppdDay).getDay()

        return getDayOfWeek(plannedDate, currentDate, formatPPD, this.messages)
    }
}